import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DeviceTypeOPEEnum} from "./DeviceTypeOPEEnum";

class ManufacturerDTO {
  id?: number;
  name?: string;
}

class MetricGroupDTO {
  id?: number;
  name?: string;
  transportConfiguration?: any;
  metrics?: MetricDTO[] = [];
}

class DataUnitDTO {
  id?: number;
  name!: string;
}

class MetricDTO {
  id?: number;
  name!: string;
  dataUnit?: DataUnitDTO;
  divider?: number | null;
  bitPosition?: number;
  decimalDigits?: number;
  transportConfiguration: any
}

/**
 * O Inner Class
 */
class O {
  id!: number;
}

class I {
  id?: number;
  modelName!: string;
  partNumber?: string;
  protocolType!: string;
  modbusWritePauseMillis?: number;
  manufacturer?: ManufacturerDTO;
  metricGroups?: MetricGroupDTO[] = [];
}


export class PutDeviceTypeCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DeviceTypeOPEEnum.PutDeviceType);
    this.i = new I();
    this.o = new O();
  }
}
